module.exports = __webpack_public_path__ + "img/17.a6b2f75b.png";